import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { selectCurrentUserProfile } from '@libs/store';
import { isCustomerSuccessEmail, routes } from '@libs/utils';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs';

// Pages only the customer success user may open; every other global admin lands on the default FFD admin tab
export const customerSuccessGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectCurrentUserProfile).pipe(
    filter((profile) => profile != null),
    take(1),
    map((profile) => isCustomerSuccessEmail(profile?.email) || router.createUrlTree(['/', routes.ffdAdmin, routes.treatmentDatabase])),
  );
};
